import { createSlice } from "@reduxjs/toolkit";

const initialDashboardSlice = {
  page: null,
  limit: null,
  totalPages: null,
  statistics: null,
  activities: [],
  interviews: [],
  listLoading: false,
  totalResults: null,
  interviewPage: null,
  actionLoading: false,
  interviewLimit: null,
  interviewTotalPages: null,
  interviewListLoading: false,
  interviewTotalResults: null,
};

export const dashboardManagementSlice = createSlice({
  name: "dashboardManagementSlice",
  initialState: initialDashboardSlice,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    interviewStartCall: (state, action) => {
      state.interviewListLoading = true;
    },
    interviewStopCall: (state, action) => {
      state.interviewListLoading = false;
    },
    getCardStatistics: (state, action) => {
      const statistics = action?.payload;
      state.statistics = statistics;
      state.listLoading = false;
    },
    getActivities: (state, action) => {
      const { activities, totalPages, page, limit, totalResults } = action.payload;
      state.activities = activities;
      state.limit = limit;
      state.page = page;
      state.totalResults = totalResults;
      state.totalPages = totalPages;
      state.listLoading = false;
    },
    getInterviews: (state, action) => {
      const { events, totalPages, page, limit, totalResults } = action.payload;
      state.interviews = events;
      state.interviewLimit = limit;
      state.interviewPage = page;
      state.interviewTotalResults = totalResults;
      state.interviewTotalPages = totalPages;
      state.interviewListLoading = false;
    },
  },
});
